import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { IronLogicConverterModeEnum } from '@zaoblako/shared/modules/pacs/enums/iron-logic-converter-mode.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link IronLogicConverterModeEnum} enumeration values */
export const IronLogicConverterModeEnumI18n: EnumI18nInterface<IronLogicConverterModeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [IronLogicConverterModeEnum.NORMAL]: 'Норма',
    [IronLogicConverterModeEnum.LOCKED]: 'Блокировка',
    [IronLogicConverterModeEnum.PASS_FREE]: 'Свободный',
    [IronLogicConverterModeEnum.PASS_FREE_PENDING]: 'Ожидание',
  },
  [I18nLocalesEnum.EN_US]: {
    [IronLogicConverterModeEnum.NORMAL]: 'Normal',
    [IronLogicConverterModeEnum.LOCKED]: 'Locked',
    [IronLogicConverterModeEnum.PASS_FREE]: 'Pass free',
    [IronLogicConverterModeEnum.PASS_FREE_PENDING]: 'Pass free pending',
  },
};
